import { render, staticRenderFns } from "./Digit.vue?vue&type=template&id=5a5e71ae&"
import script from "./Digit.vue?vue&type=script&lang=js&"
export * from "./Digit.vue?vue&type=script&lang=js&"
import style0 from "./Digit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports